import { render } from "./PublicationWriting.vue?vue&type=template&id=4d2db645&scoped=true"
import script from "./PublicationWriting.vue?vue&type=script&lang=js"
export * from "./PublicationWriting.vue?vue&type=script&lang=js"

import "./PublicationWriting.vue?vue&type=style&index=0&id=4d2db645&lang=stylus&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d2db645"]])

export default __exports__